export default class ProductAjax {
    constructor() {
        this.LANGUAGE = '/' + document.documentElement.lang;
        //Cart
        this.addToCartURL = this.LANGUAGE + '/add/to/cart';
        this.checkAvailableURL = this.LANGUAGE + '/cart/check/available';
        //this.addToCartIdsURL = this.LANGUAGE + '/add/to/cart/ids';
        this.getCartURL = this.LANGUAGE + '/get/cart/product';
        this.deleteCartURL = this.LANGUAGE + '/delete/cart/product';
        this.setCartURL = this.LANGUAGE + '/set/cart/count/product';
        //Favorite
        this.addToFavoriteURL = this.LANGUAGE + '/add/to/toggle/favorite';
    }

    /**
     *
     * @param url
     * @param callback
     * @private
     */
    _GET(url, callback) {
        $.ajax({
            type: "GET",
            url: url,
            processData: false,
            contentType: false,
            dataType: "json"
        }).done(function (res) {
            callback(res);
        });
    }

    /**
     *
     * @param url
     * @param data
     * @param callback
     * @private
     */
    _POST(url, data, callback) {
        let formData = new FormData();

        if(data) {
            for (let property in data) {
                formData.append(property, data[property]);
            }
        }

        $.ajax({
            type: "POST",
            url: url,
            processData: false,
            contentType: false,
            data: formData,
            dataType: "json"
        }).done(function (res) {
            callback(res);
        });
    }

    /**
     *
     * @param confName
     */
    confirmDelete(confName) {
        $('#deleteModal .btn').on('click', function (e){
            e.preventDefault();

            $(document).trigger(confName);
            $('#deleteModal .close').trigger('click');
        });
    }
}
